<template>
  <generic-button
      @click="$emit('click')"
      :variant="variant"
      icon="clock"
      :size="size"
  />
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import GenericButton from './Button'

export default {
  components: {
    GenericButton
  },
  props: {
    withBorder: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const variant = computed(() => {
      if (props.withBorder) {
        return 'outline-primary'
      } else {
        return 'flat-primary'
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed
      variant

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>